import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/DropdownSystem.css";
import App from "./App";
import GlobalTableEnhancer from "./components/GlobalTableEnhancer";
import GlobalButtonEnhancer from "./components/GlobalButtonEnhancer";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/ButtonSystem.css";
import axios from "axios";

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <>
      <GlobalTableEnhancer />
      <GlobalButtonEnhancer />
      <App />
    </>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
